const tpl = `<div id="mc_embed_signup">
                <form action="https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&amp;id=0145c54df5" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                    <div id="mc_embed_signup_scroll">
                        <div class="mc-field-group">
                            <div class="email-wrapper">
                                <span class="prefix-email"></span>
                                <input type="email" value="" placeholder="{{placeholder}}" name="EMAIL" class="required email" id="mce-EMAIL">
                            </div>
                        </div>
                        <div id="mce-responses" class="clear">
                            <div class="response" id="mce-error-response" style="display:none"></div>
                            <div class="response" id="mce-success-response" style="display:none"></div>
                        </div>
                        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_80218c17c3ffb8d06454fa749_0145c54df5" tabindex="-1" value=""></div>
                        <input type="submit" value="{{send_btn}}" name="subscribe" id="mc-embedded-subscribe" class="button">
                        <div class="email-response-msg"></div>
                    </div>
                </form>
            </div>`;

const tpl_jp = `<div id="mc_embed_signup">
                <form action="https://ecoflow.us8.list-manage.com/subscribe/post?u=d002bf04842356c4c1c5221cf&amp;id=bfd2f8459d" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                    <div id="mc_embed_signup_scroll">
                        <div class="mc-field-group">
                            <div class="email-wrapper">
                                <span class="prefix-email"></span>
                                <input type="email" value="" placeholder="{{placeholder}}" name="EMAIL" class="required email" id="mce-EMAIL">
                            </div>
                        </div>
                        <div id="mce-responses" class="clear">
                            <div class="response" id="mce-error-response" style="display:none"></div>
                            <div class="response" id="mce-success-response" style="display:none"></div>
                        </div>
                        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_d002bf04842356c4c1c5221cf_bfd2f8459d" tabindex="-1" value=""></div>
                        <input type="submit" value="{{send_btn}}" name="subscribe" id="mc-embedded-subscribe" class="button">
                        <div class="email-response-msg"></div>
                    </div>
                </form>
            </div>`;

function compile(tpl: string, data: any) {
    let htmlStr = tpl;
    for (const item in data) {
        if (data.hasOwnProperty(item)) {
            const regx = new RegExp(`{{${item}}}`, 'g');
            htmlStr = htmlStr.replace(regx, data[item]);
        }
    }
    return htmlStr;
}

export default function useCodeSegment(data: any, locale: string) {
    return compile(locale === 'jp' ? tpl_jp : tpl, data);
}
